import React from "react";
import { Route, Routes } from "react-router-dom";

import PermissionsTable from "./PermissionsTable";

const PermissionsList = () => <PermissionsTable />;

type Props = { onRouteNotFound?: () => void };

export default class Permissions extends React.Component<Props> {
  render() {
    const { onRouteNotFound } = this.props;
    return (
      <Routes>
        <Route path="/" element={<PermissionsList />} />
        <Route
          path="*"
          element={
            onRouteNotFound ? (
              (() => {
                onRouteNotFound();
                return null;
              })()
            ) : (
              <p>404 Not Found</p>
            )
          }
        />
      </Routes>
    );
  }
}
